module.exports = __webpack_public_path__ + "static/media/Rainbow_Badge.82f8f7cd.png";